export default {
  methods: {
    stzhToastbar(toastInfo) {
      const stzhToastbar = document.querySelector('stzh-toastbar');

      if (!stzhToastbar) return;

      toastInfo.forEach((n) => {
        stzhToastbar.toast(n.description, { type: n.type, hideAfter: 3 });
      });
    },
  },
};
